import React from 'react';
import { Archive, X } from 'lucide-react';
import { useStagingTray } from '../../context/StagingTrayContext';

const StagingTrayIndicator = () => {
  const { itemCount, toggleTray, clearTray } = useStagingTray();

  if (itemCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-40">
      <div className="bg-blue-600 dark:bg-blue-700 text-white rounded-lg shadow-lg p-3 flex items-center gap-3">
        <button
          onClick={toggleTray}
          className="flex items-center gap-2 hover:bg-blue-700 dark:hover:bg-blue-600 px-2 py-1 rounded transition-colors"
        >
          <Archive size={16} />
          <span className="font-medium">{itemCount} saved</span>
        </button>
        
        <button
          onClick={clearTray}
          className="hover:bg-blue-700 dark:hover:bg-blue-600 p-1 rounded transition-colors"
          title="Clear tray"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default StagingTrayIndicator;